document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.dropdown');
  if (!dropdowns.length) return;

  // --- Utility functions ---
  const updateSingleSelect = (dropdown, option) => {
    const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
    placeholderText.textContent = option.textContent.trim();
    placeholderText.dataset.ehrm = option.dataset.ehrm || '';

    dropdown.classList.remove('is-open');
    dropdown.classList.add('is-selected');
  };

  const updateMultiSelect = (dropdown) => {
    const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
    const defaultPlaceholder = placeholderText.dataset.placeholder;
    const { originalPlaceholder } = placeholderText.dataset;

    const selectedOptions = [...dropdown.querySelectorAll('.dropdown__list-inner input:checked')].map((input) =>
      input.nextElementSibling.textContent.trim(),
    );

    placeholderText.textContent =
      selectedOptions.length > 0 ? selectedOptions.join(', ') : originalPlaceholder || defaultPlaceholder;

    dropdown.classList.toggle('is-selected', selectedOptions.length > 0);
  };

  const initDropdown = (dropdown) => {
    const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
    const defaultPlaceholder = placeholderText.dataset.placeholder;
    const { originalPlaceholder } = placeholderText.dataset;

    if (dropdown.classList.contains('dropdown--multiselect')) {
      updateMultiSelect(dropdown);
      return;
    }

    const checkedInput = dropdown.querySelector('.dropdown__list-inner input:checked');
    if (checkedInput) {
      const optionLabel = checkedInput.nextElementSibling;
      placeholderText.textContent = optionLabel?.textContent.trim();
      dropdown.classList.add('is-selected');
      return;
    }

    placeholderText.textContent = originalPlaceholder || defaultPlaceholder;
  };

  // --- Initialize all dropdowns ---
  dropdowns.forEach(initDropdown);

  // --- Global click handler (event delegation) ---
  document.addEventListener('click', (event) => {
    const dropdown = event.target.closest('.dropdown');

    // Close all others
    dropdowns.forEach((d) => {
      if (d !== dropdown) {
        d?.classList.remove('is-open');
        d.querySelector('.dropdown__search-input')?.blur();
      }
    });

    if (!dropdown) return;

    // Toggle open
    if (event.target.closest('.dropdown__placeholder')) {
      dropdown.classList.toggle('is-open');

      setTimeout(() => {
        dropdown.querySelector('.dropdown__search-input')?.focus();
      }, 50);

      return;
    }

    // Handle single-select option click
    const option = event.target.closest('.dropdown__list-option');
    if (option && !dropdown.classList.contains('dropdown--multiselect')) {
      updateSingleSelect(dropdown, option);
    }
  });

  // --- Multi-select: listen to checkbox changes ---
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.dropdown--multiselect .dropdown__list-inner input');
    if (!input) return;
    const dropdown = input.closest('.dropdown');
    updateMultiSelect(dropdown);
  });

  // --- Search filter ---
  document.querySelectorAll('.dropdown__search-input').forEach((input) => {
    input.addEventListener('input', () => {
      const searchValue = input.value.toLowerCase();
      input
        .closest('.dropdown')
        .querySelectorAll('.dropdown__list-item')
        .forEach((item) => {
          const option = item.querySelector('.dropdown__list-option');
          const isMatch = option.textContent.toLowerCase().includes(searchValue);

          item.classList.toggle('is-hidden', !isMatch);
        });
    });
  });

  // --- Reset search inputs on outside click ---
  document.addEventListener('click', (event) => {
    if (event.target.closest('.dropdown')) return;

    document.querySelectorAll('.dropdown__search-input').forEach((input) => {
      input.value = '';
      input
        .closest('.dropdown')
        .querySelectorAll('.dropdown__list-item')
        .forEach((item) => {
          item.classList.remove('is-hidden');
        });
    });
  });

  // --- KEYBOARD ACCESSIBILITY FOR CUSTOM DROPDOWNS ---
  dropdowns.forEach((dropdown) => {
    const placeholder = dropdown.querySelector('.dropdown__placeholder');
    const items = [...dropdown.querySelectorAll('.dropdown__list-item')];
    const inputs = [...dropdown.querySelectorAll('input[data-input-group-field]')];

    let activeIndex = 0;

    // Make LI items tabbable
    items.forEach((item) => item.setAttribute('tabindex', '0'));

    const openDropdown = () => {
      dropdown.classList.add('is-open');

      activeIndex = inputs.findIndex((i) => i.checked);

      highlightItem(activeIndex);

      setTimeout(() => {
        dropdown.querySelector('.dropdown__search-input')?.focus();
      }, 50);
    };

    const closeDropdown = () => {
      dropdown.classList.remove('is-open');
      activeIndex = -1;
      placeholder.focus();
    };

    const highlightItem = (index) => {
      items.forEach((i) => i.classList.remove('is-active'));
      items[index]?.classList.add('is-active');
    };

    const selectItem = (index) => {
      const input = items[index].querySelector('input');
      if (!input || input.disabled) return;

      input.checked = !input.checked;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      if (dropdown.classList.contains('dropdown--multiselect')) {
        updateMultiSelect(dropdown);
        return;
      }

      updateSingleSelect(dropdown, input.nextElementSibling);
      closeDropdown();
    };

    items.forEach((item, index) => {
      item.addEventListener('focus', () => {
        activeIndex = index;
        highlightItem(index);
      });
    });

    // eslint-disable-next-line consistent-return
    dropdown.addEventListener('keydown', (e) => {
      if (e.target.matches('.dropdown__search-input') && !['Escape', 'ArrowUp', 'ArrowDown', 'Enter'].includes(e.key)) {
        return;
      }

      const isOpen = dropdown.classList.contains('is-open');

      switch (e.key) {
        case ' ':
        case 'Enter':
          e.preventDefault();
          if (!isOpen) {
            // eslint-disable-next-line consistent-return
            return openDropdown();
          }
          selectItem(activeIndex);
          break;

        case 'ArrowDown':
          e.preventDefault();
          // eslint-disable-next-line consistent-return
          if (!isOpen) return openDropdown();
          activeIndex = (activeIndex + 1) % items.length;
          highlightItem(activeIndex);
          items[activeIndex].focus();
          break;

        case 'ArrowUp':
          e.preventDefault();
          // eslint-disable-next-line consistent-return
          if (!isOpen) return openDropdown();
          activeIndex = (activeIndex - 1 + items.length) % items.length;
          highlightItem(activeIndex);
          items[activeIndex].focus();
          break;

        case 'Escape':
          if (isOpen) closeDropdown();
          break;

        case 'Tab':
          // allow natural tabbing
          break;

        default:
      }
    });

    dropdown.addEventListener('focusout', (e) => {
      if (!dropdown.contains(e.relatedTarget)) {
        dropdown.classList.remove('is-open');
      }
    });
  });
});
